import SlideLayout from './SlideLayout';

function PersonaCard({ scenario, sharedQuestion, onAskQuestion }) {
  const displayName = scenario.display_name || scenario.label || 'Demo member';
  const firstName = displayName.split(/\s+/)[0] || displayName;
  const isRisk = String(scenario.label || '')
    .toLowerCase()
    .includes('risk');
  const statusDotClass = isRisk ? 'bg-tf-terracotta-mid' : 'bg-tf-teal';
  const statusText = isRisk ? 'At risk' : 'On track';
  const statusTextClass = isRisk ? 'text-tf-terracotta-mid' : 'text-tf-teal';
  const highlights = Array.isArray(scenario.highlights) ? scenario.highlights : [];

  return (
    <article className="flex h-full flex-col gap-5 border border-tf-stone bg-tf-surface p-6 sm:p-7">
      <div className="space-y-2">
        <div className="flex min-h-[2.6rem] items-start justify-between gap-3">
          <p className="text-[11px] font-medium uppercase tracking-[0.16em] text-tf-ink/55">
            {scenario.label}
          </p>
          <span
            className={`inline-flex flex-shrink-0 items-center gap-1.5 text-[11px] font-medium uppercase tracking-[0.12em] ${statusTextClass}`}
          >
            <span className={`h-2 w-2 rounded-full ${statusDotClass}`} aria-hidden="true" />
            {statusText}
          </span>
        </div>
        <h3 className="text-[20px] font-light leading-[1.2] text-tf-ink sm:text-[22px]">
          {displayName}
        </h3>
      </div>

      {highlights.length > 0 ? (
        <dl className="grid gap-2 border-t border-tf-stone pt-4 text-[13.5px] font-light text-tf-ink/75">
          {highlights.map((highlight) => (
            <div key={highlight}>{highlight}</div>
          ))}
        </dl>
      ) : null}

      <button
        type="button"
        onClick={() => onAskQuestion(sharedQuestion, scenario.code)}
        className="group mt-auto inline-flex items-center justify-between gap-3 border border-tf-stone bg-tf-canvas px-4 py-3 text-left text-[14px] font-medium text-tf-ink transition-colors hover:border-tf-teal hover:bg-white sm:px-5"
      >
        <span>Ask as {firstName}</span>
        <span className="text-tf-teal-mid transition-transform group-hover:translate-x-0.5">→</span>
      </button>
    </article>
  );
}

export default function SectionTryIt({
  headline,
  intro,
  scenarios,
  sharedQuestion,
  onAskQuestion,
}) {
  const personas = Array.isArray(scenarios) ? scenarios.slice(0, 3) : [];
  if (personas.length === 0 || !sharedQuestion) return null;

  const gridColsClass = personas.length >= 3 ? 'sm:grid-cols-2 lg:grid-cols-3' : 'sm:grid-cols-2';

  return (
    <SlideLayout eyebrow="Try it" title={headline} intro={intro}>
      <div className={`grid gap-4 sm:gap-5 ${gridColsClass}`}>
        {personas.map((scenario) => (
          <PersonaCard
            key={scenario.code || scenario.label}
            scenario={scenario}
            sharedQuestion={sharedQuestion}
            onAskQuestion={onAskQuestion}
          />
        ))}
      </div>
    </SlideLayout>
  );
}
